import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import searchIcon from "../../assets/images/icon_search.svg";
import { SEARCH_TEXT_MAX_LENGTH } from "../../common/constants";

export interface SoftwareSearchProps {
  onClick: (text: string) => void;
}

const SoftwareSearch: React.FC<SoftwareSearchProps> = ({
  onClick = (text: string) => {
    /* Empty Function */
  },
}): JSX.Element => {
  const { t } = useTranslation();
  const [searchText, SetSearchText] = useState("");

  return (
    <SearchSection>
      <SearchDl>
        <SearchDt>
          {t("softwarePage.label.licenseNumber")}
          <br />({t("softwarePage.label.partialMatch")})
        </SearchDt>
        <SearchDd>
          <SearchInput
            type="text"
            size={40}
            maxLength={SEARCH_TEXT_MAX_LENGTH}
            name=""
            placeholder={t("softwarePage.label.searchPlaceholder")}
            value={searchText}
            onChange={(event) => SetSearchText(event.target.value)}
          />
        </SearchDd>
        <SearchDd>
          <SearchButton
            type="button"
            name="search"
            value={t("softwarePage.label.searchButton")}
            onClick={() => onClick(searchText)}
          />
        </SearchDd>
      </SearchDl>
    </SearchSection>
  );
};

export default SoftwareSearch;

const SearchSection = styled.section`
  position: sticky;
  top: 115px;
  margin-bottom: 5rem;
  border-bottom: 2px #e6e6e6 solid;
  background: #ffffff;
  z-index: 1; // To render over positioned elements without stacking contexts.
`;

const SearchDl = styled.dl`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const SearchDt = styled.dt`
  padding: 1.7rem 1rem;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
`;

const SearchDd = styled.dd`
  padding: 1.7rem 1rem;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
`;

const SearchInput = styled.input`
  border: 1px #999999 solid;
  background: url(${searchIcon}) no-repeat 95% center;
  :focus {
    background: #fafafa url(${searchIcon}) no-repeat 95% center;
    outline: 0;
  }
`;

const SearchButton = styled.input`
  cursor: pointer;
`;
